import React, { useState, useEffect } from 'react';
import './styles.scss';
import { toast } from 'react-toastify';
import { Input, Button, ToastMessage, Breadcrumbs } from '@cokitchen/cokitchen-components';
import { apiService } from 'services/base.service';
import { ROUTE_KEYS } from 'utils/constants';
import { handleApiError } from 'utils/functions';

const ConversionRate = () => {
  const [loading, setLoading] = useState(false);
  const [conversionRate, setConversionRate] = useState('');

  const fetchRewardPoints = async () => {
    setLoading(true);

    try {
      const response = await apiService.get(`loyalty/internal/points/misc`, {
        isInternal: true
      });
      setConversionRate(Number(response.data[0].conversion_rate ?? '0').toFixed(4));
    } catch (err) {
      handleApiError(err);
    } finally {
      setLoading(false);
    }
  };

  const updateConversionRate = async () => {
    setLoading(true);
    try {
      setLoading(true);
      await apiService.put(`loyalty/internal/points/misc`, {
        isInternal: true,
        data: {
          conversion_rate: Number(conversionRate)
        }
      });
      toast(<ToastMessage type='success' message='Conversion rate has been updated' />);
    } catch (err: any) {
      handleApiError(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRewardPoints();
  }, []);

  const breadcrumbs = [
    { name: 'Maintenance', path: ROUTE_KEYS.MAINTENANCE },
    {
      name: 'Conversion rate',
      path: ''
    }
  ];

  return (
    <div>
      <Breadcrumbs breadcrumbs={breadcrumbs} />
      <div className='w-full flex justify-center items-center pt-[68px]'>
        <div className='edit-conversion-rate-form'>
          <div className='flex flex-col gap-1'>
            <h6 className='text-2xl font-semibold'>Edit conversion rate</h6>
            <p className='font-medium text-sm text-gray-5'>
              Manage payment options on the FoodCourt App
            </p>
          </div>

          <Input
            small
            type='number'
            min={0}
            value={conversionRate}
            currency
            label='One FC point is equals to'
            onChange={(e) => setConversionRate(e.target.value)}
          />

          <Button
            small
            onClick={updateConversionRate}
            color='primary'
            variant='block'
            className='max-w-[187px] self-end'
            loading={loading}
            disabled={!conversionRate}>
            Update
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ConversionRate;
